// React
import React from 'react';

// Mantine
import { Paper, Skeleton, Stack, useComputedColorScheme } from '@mantine/core';
import { useHover } from '@mantine/hooks';

interface StyledPaperProps {
  isLoading?: boolean;
  children: React.ReactNode;
  isMobile?: boolean;
  testId?: string;
}

export const StyledPaper: React.FC<StyledPaperProps> = ({
  isLoading,
  children,
  isMobile,
  testId = 'metric-card',
}) => {
  const colorScheme = useComputedColorScheme('dark');
  const isDark = colorScheme === 'dark';
  const background = isDark ? '#26282E' : '#EFF0F5';
  const { hovered, ref } = useHover();

  return (
    <Paper
      withBorder
      radius="lg"
      ref={ref}
      p="lg"
      w="100%"
      data-testid={testId}
      style={{
        height: '100%',
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        overflow: 'hidden',
        background: background,
        borderColor: isDark ? 'rgba(255,255,255,0.06)' : 'rgba(15,23,42,0.08)',
        boxShadow: hovered
          ? '0 18px 40px rgba(15,23,42,0.32)'
          : '0 12px 30px rgba(15,23,42,0.22)',
        backdropFilter: 'blur(16px)',
        transition:
          'transform 120ms ease, box-shadow 120ms ease, border-color 120ms ease',
        cursor: 'default',
        transform: hovered ? 'translateY(-2px)' : 'translateY(0)',
      }}
    >
      {isLoading ? (
        <Stack data-testid="metric-card-skeleton" gap={isMobile ? 'md' : 'sm'}>
          <Skeleton height={18} />
          <Skeleton height={18} />
          <Skeleton height={18} />
          <Skeleton height={18} />
        </Stack>
      ) : (
        <>{children}</>
      )}
    </Paper>
  );
};
